import styled, { keyframes } from 'styled-components'
import * as Dialog from '@radix-ui/react-dialog'

const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const contentShow = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`

export const Root = Dialog.Root

export const Portal = Dialog.Portal

export const Overlay = styled(Dialog.Overlay)`
  position: fixed;
  z-index: 998;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  animation: ${overlayShow} 0.2s cubic-bezier(0.16, 1, 0.3, 1);
`

export const Content = styled(Dialog.Content)`
  position: fixed;
  z-index: 999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${(props) => props.theme.colors.gray[10]};
  padding: 3rem 1rem 3rem 2rem;
  border-radius: 6px;
  animation: ${contentShow} 0.2s 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
`

export const Title = styled(Dialog.Title)`
  margin-bottom: 1rem;
`

export const Description = styled(Dialog.Description)``

export const Close = styled(Dialog.Close)`
  border: 0;
  background: transparent;
  color: ${(props) => props.theme.colors.gray[100]};
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`
